import React from 'react';
import { Box, Typography } from '@mui/material';
import CollectionInquiryBadge from '../../../Components/CollectionInquiryBadge';
import CollectionLeadsButton from './CollectionLeadsButton';
import { cadDetailCountsSx, detailListMetaRowSx } from './UserLotListsPanel.styles';

/**
 * Fila bajo el nombre de la lista: conteo a la izquierda, consultas a la derecha.
 * Sin chip “Lista” ni label “Actividad”. El visitante no ve consultas (total/unseen 0).
 *
 * Leads (F1/F2): con `leads` (owner / editor de Espacio y `getleadcounts` OK)
 * la derecha es “Leads y consultas” con el badge `unseen_leads` y abre
 * `CollectionLeadsDialog`. Sin `leads` queda el badge de consultas (mismo
 * modal). El menú ⋮ también dice “Leads y consultas”.
 *
 * Oculto por decisión de la meet del 2026-10-15: no se usa por ahora
 * (utilidad muy puntual). Reactivar si se necesita.
 * (`SHOW_COLLECTION_LEADS_FROM_LIST_DETAIL` en leadCollections.js).
 */
export default function ListDetailInquiryMetaRow({
  countsLabel = '',
  total = 0,
  unseen = 0,
  sx,
  onOpenInquiries,
  leads = null,
}) {
  const label = String(countsLabel || '').trim();
  if (!label && !total && !unseen && !leads) return null;
  return (
    <Box sx={{ ...detailListMetaRowSx, ...sx }}>
      <Typography sx={{ ...cadDetailCountsSx, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {label}
      </Typography>
      {leads ? (
        <CollectionLeadsButton unseen={leads.unseen} onClick={leads.onOpen} />
      ) : (
        <CollectionInquiryBadge
          total={total}
          unseen={unseen}
          onClick={onOpenInquiries}
        />
      )}
    </Box>
  );
}
